// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"443":"c9914d98","448":"f693d9d5","471":"a878bf09","542":"37b1d9b4","861":"867798f7","980":"3ad4fb26"}[chunkId] + ".css";
};